var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomEyeTracking = function SvgCustomEyeTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "custom-eye-tracking_svg__Layer_1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".custom-eye-tracking_svg__cls-1,.custom-eye-tracking_svg__cls-2{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:1.75px}.custom-eye-tracking_svg__cls-2{stroke-linecap:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.57c4.37 0 8.24-2.13 10.62-5.41.5-.69.5-1.63 0-2.32C20.23 7.56 16.36 5.43 12 5.43S3.76 7.56 1.38 10.84c-.5.69-.5 1.63 0 2.32 2.39 3.28 6.26 5.41 10.62 5.41Z",
    className: "custom-eye-tracking_svg__cls-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.24,
    className: "custom-eye-tracking_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 1H1v4.3M23 5.3V1h-4.3M1 18.7V23h4.3M18.7 23H23v-4.3M12 20.08V3.92M20.08 12H3.92",
    className: "custom-eye-tracking_svg__cls-2"
  })));
};
export default SvgCustomEyeTracking;